var React = require('react');

function WinterSports (props) {
    return React.createElement("svg",props,React.createElement("g",{"fill":"none","fillRule":"evenodd"},React.createElement("g",{"strokeLinecap":"round","strokeLinejoin":"round"},React.createElement("path",{"d":"M11.563 7.345L8 2 1 14h6.958M18.437 7.345L22 2l7 12h-6.958M11.208 8h7.584M15 1l13 24H2z"}))));
}

WinterSports.defaultProps = {"width":"30","height":"26","viewBox":"0 0 30 26"};

module.exports = WinterSports;

WinterSports.default = WinterSports;
